import React, { Component } from "react";
import {
  Card, CardBody, Table, Badge, Button, Input, Row, Col,
  Modal, ModalHeader, ModalBody,
} from "reactstrap";
import AiAdminLayout from "./layout";
import { fetchApi } from "./api";

class AiAdminAuditLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      total: 0,
      page: 1,
      pages: 1,
      shopFilter: "",
      fromDate: "",
      toDate: "",
      loading: true,
      // Detail modal
      detailModal: false,
      detailLog: null,
    };
  }

  async componentDidMount() {
    await this.loadLogs();
  }

  loadLogs = async () => {
    const { page, shopFilter, fromDate, toDate } = this.state;
    this.setState({ loading: true });
    try {
      let params = `?page=${page}&limit=20`;
      if (shopFilter) params += `&shop_id=${shopFilter}`;
      if (fromDate) params += `&from=${fromDate}`;
      if (toDate) params += `&to=${toDate}`;
      const data = await fetchApi(`/audit-logs${params}`);
      this.setState({
        logs: data.logs,
        total: data.total,
        pages: data.pages,
        loading: false,
      });
    } catch (err) {
      console.error("Audit logs load error:", err);
      this.setState({ loading: false });
    }
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage }, this.loadLogs);
  };

  render() {
    const {
      logs, total, page, pages, shopFilter, fromDate, toDate,
      loading, detailModal, detailLog,
    } = this.state;

    return (
      <AiAdminLayout>
        <h4 className="font-weight-bold mb-4">Audit Logs</h4>

        <Card style={{ borderRadius: 8 }}>
          <CardBody>
            {/* Filters */}
            <Row className="mb-3">
              <Col md={2}>
                <Input
                  type="number"
                  bsSize="sm"
                  placeholder="Shop ID"
                  value={shopFilter}
                  onChange={(e) => this.setState({ shopFilter: e.target.value })}
                />
              </Col>
              <Col md={3}>
                <Input
                  type="date"
                  bsSize="sm"
                  value={fromDate}
                  onChange={(e) => this.setState({ fromDate: e.target.value })}
                  placeholder="From"
                />
              </Col>
              <Col md={3}>
                <Input
                  type="date"
                  bsSize="sm"
                  value={toDate}
                  onChange={(e) => this.setState({ toDate: e.target.value })}
                  placeholder="To"
                />
              </Col>
              <Col md={2}>
                <Button size="sm" color="primary" onClick={() => this.setState({ page: 1 }, this.loadLogs)}>
                  Filter
                </Button>
              </Col>
              <Col md={2} className="text-right">
                <small className="text-muted">Total: {total}</small>
              </Col>
            </Row>

            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border spinner-border-sm text-primary" />
              </div>
            ) : logs.length === 0 ? (
              <p className="text-muted text-center py-4">No audit logs found</p>
            ) : (
              <>
                <Table responsive size="sm" style={{ fontSize: 12 }}>
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th>Shop</th>
                      <th>Intent</th>
                      <th>Input</th>
                      <th>Tools</th>
                      <th>Response</th>
                      <th>Tokens</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log) => (
                      <tr key={log.id}>
                        <td style={{ fontSize: 11, whiteSpace: "nowrap" }}>
                          {new Date(log.createdAt).toLocaleString("vi-VN")}
                        </td>
                        <td>
                          <Badge color="light" className="text-dark">
                            #{log.shop_id}
                          </Badge>
                        </td>
                        <td>
                          <Badge
                            color={
                              log.intent_detected === "DATA_QUERY"
                                ? "primary"
                                : log.intent_detected === "KNOWLEDGE_QUERY"
                                ? "info"
                                : log.intent_detected === "ACTION_REQUEST"
                                ? "warning"
                                : "secondary"
                            }
                            style={{ fontSize: 10 }}
                          >
                            {log.intent_detected || "—"}
                          </Badge>
                        </td>
                        <td style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {log.input_text || "—"}
                        </td>
                        <td>
                          {log.tool_calls && Array.isArray(log.tool_calls)
                            ? log.tool_calls.map((tc, i) => (
                                <Badge key={i} color="light" className="text-dark mr-1" style={{ fontSize: 10 }}>
                                  {tc.tool}
                                </Badge>
                              ))
                            : "—"}
                        </td>
                        <td style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {log.final_response ? log.final_response.substring(0, 80) : "—"}
                        </td>
                        <td style={{ fontSize: 10, whiteSpace: "nowrap" }}>
                          {log.token_usage ? (
                            <span title={`In: ${log.token_usage.input_tokens} | Out: ${log.token_usage.output_tokens}`}>
                              {log.token_usage.total_tokens?.toLocaleString() || "—"}
                            </span>
                          ) : "—"}
                        </td>
                        <td>
                          <Button
                            color="link"
                            size="sm"
                            className="p-0"
                            onClick={() => this.setState({ detailModal: true, detailLog: log })}
                          >
                            <i className="simple-icon-magnifier" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination */}
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    size="sm"
                    color="secondary"
                    disabled={page <= 1}
                    onClick={() => this.handlePageChange(page - 1)}
                    className="mr-2"
                  >
                    Previous
                  </Button>
                  <span className="align-self-center mx-2" style={{ fontSize: 13 }}>
                    {page} / {pages}
                  </span>
                  <Button
                    size="sm"
                    color="secondary"
                    disabled={page >= pages}
                    onClick={() => this.handlePageChange(page + 1)}
                  >
                    Next
                  </Button>
                </div>
              </>
            )}
          </CardBody>
        </Card>

        {/* Detail Modal */}
        <Modal isOpen={detailModal} toggle={() => this.setState({ detailModal: false })} size="lg">
          <ModalHeader toggle={() => this.setState({ detailModal: false })}>
            Audit Log Detail
          </ModalHeader>
          <ModalBody>
            {detailLog && (
              <div style={{ fontSize: 13 }}>
                <Row className="mb-2">
                  <Col md={3}><strong>Time:</strong></Col>
                  <Col md={9}>{new Date(detailLog.createdAt).toLocaleString("vi-VN")}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Shop ID:</strong></Col>
                  <Col md={9}>{detailLog.shop_id}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Session:</strong></Col>
                  <Col md={9}>{detailLog.session_id || "—"}</Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Intent:</strong></Col>
                  <Col md={9}>
                    <Badge color="primary">{detailLog.intent_detected || "—"}</Badge>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Input:</strong></Col>
                  <Col md={9}>
                    <div className="p-2 rounded" style={{ backgroundColor: "#f8f9fa", whiteSpace: "pre-wrap" }}>
                      {detailLog.input_text || "—"}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Tool Calls:</strong></Col>
                  <Col md={9}>
                    <pre
                      className="p-2 rounded"
                      style={{ backgroundColor: "#f8f9fa", fontSize: 11, maxHeight: 200, overflow: "auto" }}
                    >
                      {JSON.stringify(detailLog.tool_calls, null, 2)}
                    </pre>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Plan:</strong></Col>
                  <Col md={9}>
                    <pre
                      className="p-2 rounded"
                      style={{ backgroundColor: "#f8f9fa", fontSize: 11, maxHeight: 200, overflow: "auto" }}
                    >
                      {JSON.stringify(detailLog.plan_json, null, 2)}
                    </pre>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Token Usage:</strong></Col>
                  <Col md={9}>
                    {detailLog.token_usage ? (
                      <div className="d-flex" style={{ gap: 12 }}>
                        <Badge color="info" className="px-2 py-1">
                          Input: {detailLog.token_usage.input_tokens?.toLocaleString()}
                        </Badge>
                        <Badge color="success" className="px-2 py-1">
                          Output: {detailLog.token_usage.output_tokens?.toLocaleString()}
                        </Badge>
                        <Badge color="dark" className="px-2 py-1">
                          Total: {detailLog.token_usage.total_tokens?.toLocaleString()}
                        </Badge>
                        <small className="text-muted align-self-center">
                          ({detailLog.token_usage.provider} / {detailLog.token_usage.model})
                        </small>
                      </div>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col md={3}><strong>Response:</strong></Col>
                  <Col md={9}>
                    <div
                      className="p-2 rounded"
                      style={{ backgroundColor: "#f8f9fa", whiteSpace: "pre-wrap", maxHeight: 300, overflow: "auto" }}
                    >
                      {detailLog.final_response || "—"}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </ModalBody>
        </Modal>
      </AiAdminLayout>
    );
  }
}

export default AiAdminAuditLogs;
